// @ts-nocheck

export const localeCodes =  [
  "fr",
  "en",
  "de"
]
export const localeLoaders = {
  fr: [
    {
      key: "locale_fr_46json_3676bfd9",
      load: () => import("#nuxt-i18n/3676bfd9" /* webpackChunkName: "locale_fr_46json_3676bfd9" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_165a3efe",
      load: () => import("#nuxt-i18n/165a3efe" /* webpackChunkName: "locale_de_46json_165a3efe" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "fr",
    name: "Français",
    iso: "fr-FR",
    language: "fr-FR"
  },
  {
    code: "en",
    name: "English",
    iso: "en-US",
    language: "en-US"
  },
  {
    code: "de",
    name: "Deutsch",
    iso: "de-DE",
    language: "de-DE"
  }
]

